// PostCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarOutlined, TagOutlined } from '@ant-design/icons';
import './index.css';

const PostCard = ({ post }) => {
  // 图片映射配置
  const imageConfig = {
    1: {
      url: `${process.env.PUBLIC_URL}/images/b.jpg`,
      fallbackColor: '#FDB927',
    },
    2: {
      url: `${process.env.PUBLIC_URL}/images/c.jpg`,
      fallbackColor: '#00538C',
    },
    3: {
      url: `${process.env.PUBLIC_URL}/images/d.jpg`,
      fallbackColor: '#CE1141',

    },

    // 默认配置（用于新文章）
    default: {
      url: `${process.env.PUBLIC_URL}/images/default.jpg`,
      fallbackColor: '#722ed1',
      fallbackText: '博客'
    }
  };

  // 获取图片配置
  const getImageConfig = (id) => {
    return imageConfig[id] || imageConfig.default;
  };

  const { url, fallbackColor, fallbackText } = getImageConfig(post.id);

  // 格式化日期
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  // 图片加载失败处理
  const handleImageError = (e) => {
    const config = getImageConfig(post.id);
    e.target.style.display = 'none';
    
    // 创建回退容器
    const fallback = document.createElement('div');
    fallback.className = 'post-card-image-fallback';
    fallback.style.backgroundColor = config.fallbackColor;
    fallback.innerHTML = `<span>${config.fallbackText}</span>`;
    
    // 替换图片元素
    e.target.parentNode.appendChild(fallback);
  };

  return (
    <div className="post-card">
      {/* 图片部分 */}
      <div className="post-card-image-container">
        <img
          src={url}
          alt={post.title}
          className="post-card-image"
          loading="lazy"
          onError={handleImageError}
        />
      </div>
      
      {/* 内容部分 */}
      <div className="post-card-content">
        <h3 className="post-card-title">
          <Link to={`/post/${post.id}`}>
            {post.title}
          </Link>
        </h3>
        
        <p className="post-card-summary">
          {post.summary || post.content?.substring(0, 100) || '暂无描述...'}
        </p>
        
        <div className="post-card-meta">
          <div className="post-card-date">
            <CalendarOutlined />
            <span>{formatDate(post.createdAt || post.date)}</span>
          </div>
          
          {post.tags && post.tags.length > 0 && (
            <div className="post-card-tags">
              <TagOutlined style={{ fontSize: 12, marginRight: 4 }} />
              {post.tags.slice(0, 2).map((tag, index) => (
                <span key={index} className="post-card-tag">
                  {tag}
                </span>
              ))}
              {post.tags.length > 2 && (
                <span className="post-card-tag">
                  +{post.tags.length - 2}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostCard;